/**
 * Recaptcha helper.
 *
 */
class RecaptchaClass {
    /**
     * Class constructor
     * Defines the default executed flag
     */
    constructor() {
        this.executed = false;
    }

    /**
     *
     * @param $el
     */
    setInputElement($el) {
        this.inputElement = $el;
    }

    /**
     * Call execute to start up recaptcha, call the script if necessary and run
     * whatever code you provide.
     *
     * @param done Success callback
     * @param fail Failure callback
     * @returns {RecaptchaClass}
     */
    execute(done, fail) {
        if (typeof window.grecaptcha === 'undefined' || !document.querySelector('#g-recaptcha-challenge').querySelector('.g-recaptcha-response')) {

            this.executed = false;
            // Async recaptcha loading callback
            window.onRecaptchaLoadCallback = () => {
                this.execute(done, fail);
            };

            this.getScript('https://www.google.com/recaptcha/api.js?hl=fr&onload=onRecaptchaLoadCallback', () => {
            });

            return this;
        }

        // Callback for success as defined in RecaptchaAwareTrait
        window.submitRecaptchaForm = () => {
            this.executed = true;
            if (this.inputElement) {
                this.inputElement.val(document.querySelector('#g-recaptcha-challenge').querySelector('.g-recaptcha-response').value);
            }
            done();
        };

        // Callback for failure as defined in RecaptchaAwareTrait
        window.failedRecaptchaForm = () => {
            this.executed = false;
            fail();
        };

        if (this.executed) {
            window.grecaptcha.reset();
        }

        window.grecaptcha.execute();
        return this;
    }

    /**
     * Vanilla getScript function
     *
     * @param src
     * @param cb
     */
    getScript (src, cb) {
        let script = document.createElement('script');
        let prior = document.getElementsByTagName('script')[0];
        // script.async = 1;

        script.onload = script.onreadystatechange = function( _, isAbort ) {
            if(isAbort || !script.readyState || /loaded|complete/.test(script.readyState) ) {
                script.onload = script.onreadystatechange = null;
                script = undefined;
                if(!isAbort && cb) setTimeout(cb, 0);
            }
        };

        script.src = src;
        prior.parentNode.insertBefore(script, prior);
    }
}

let RecaptchaInstance = new RecaptchaClass();

export { RecaptchaInstance as Recaptcha };
